import { APIModel } from './api-model.model'

export class APIReportChartType extends APIModel {
    chartTypeId: number;
    chartTypeName: string;
    chartTypeEnabled: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        chartTypeId: number;
        chartTypeName: string;
        chartTypeEnabled: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.chartTypeId = params.chartTypeId
        this.chartTypeName = params.chartTypeName
        this.chartTypeEnabled = params.chartTypeEnabled ? 1 : 0
    }
}
